import { createFileRoute, redirect } from '@tanstack/react-router';
import { esperarSesion } from '@/lib/sesion';
import { Shell } from '@/shell/Shell';

// Everything under this layout requires a session with valid claims.
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ location }) => {
    const s = await esperarSesion();
    if (s.estado !== 'activa') {
      throw redirect({
        to: '/ingresar',
        search: { redirect: location.href === '/' ? undefined : location.href },
      });
    }
    // Temporary password from an admin: replace it before anything else.
    if (s.debeCambiarPassword) throw redirect({ to: '/cambiar-clave', replace: true });
    // The platform superadmin has no workshop: its only pages are /plataforma.
    if (!s.tallerId && !location.pathname.startsWith('/plataforma')) {
      throw redirect({ to: '/plataforma/talleres', replace: true });
    }
    return { sesion: s };
  },
  component: Shell,
});
